import { Component, OnInit } from '@angular/core';
import { WorkflowCard } from '../../../../class/workflow.type';
import { WorkflowService } from '../../../../service/workflow/workflow.service';
import { CardElementsBaseComponent } from '../card-elements-base.component';

@Component({
  selector: 'cu-dynamic-card-header',
  templateUrl: './card-header.component.html',
  styleUrls: ['./card-header.component.scss']
})
export class CardHeaderComponent extends CardElementsBaseComponent implements OnInit {
  /**
   * Return title of card
   */
  // TODO: revisit / refactor
  // Refactor this method to implement different way of displaying card title with iteration
  public get title(): string {
    const card = this.card;
    const config = card.config;
    const cardTitle = card.title;
    const replacementId = this.totalCards(config) > 1 ? ` ${card.iterationId + 1}` : '';
    if (config.titleFn) {
      return card.customTitleOrDefault;
    }

    if (card.iterationId != null && Array.isArray(config.title)) {
      if (cardTitle[card.iterationId]) {
        return cardTitle[card.iterationId].replace(/ {{\$}}/g, replacementId);
      }
      return cardTitle[config.title.length - 1].replace(/ {{\$}}/g, replacementId);
    }
    return cardTitle;
  }

  // TODO: revisit / refactor
  // Refactor ro remove the workflow service, this component should not have dependency to workflowService
  constructor(private readonly workflowService: WorkflowService) {
    super();
  }

  public ngOnInit(): void {}

  private totalCards(config: WorkflowCard): number {
    const cardId = config && config.id && config.id.split('$')[0];
    const cards = this.workflowService && this.workflowService.currentPage ? this.workflowService.currentPage.cards : undefined;
    return cards ? cards.filter((t) => t.id.startsWith(cardId)).length : 0;
  }
}
